import { directiveEntryFormSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/directiveEntryFormSteps.constant'
import { MaintenanceForwardingsDirectiveFromSteps } from '@/features/maintenanceWorkflow/pages/Show/features/forwardings/constants/maintenanceForwardingsShowDirectiveDetails.type'
import { useEffect, useState } from 'react'
import { useFormContext } from 'react-hook-form'

export const useCreateForwardingFormStepValidation = (
  step: MaintenanceForwardingsDirectiveFromSteps,
  dependencies: (string | number | boolean | null | undefined)[],
) => {
  const { getValues } = useFormContext()

  const [isValid, setIsValid] = useState(false)

  const isStepValid = async (): Promise<boolean> => {
    const schemaForStep = directiveEntryFormSteps[step]?.schema

    if (!schemaForStep) return false

    const values = getValues()
    const result = await schemaForStep.safeParseAsync(values)

    return result.success
  }

  useEffect(() => {
    isStepValid().then(setIsValid)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, dependencies)

  return { isValid }
}
